import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Pathurl from "../Class/Pathurl.json";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ConfigETC from "../Class/ConfigETC.json";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  Class_ETC_MsgError,
  Class_ETC_MsgSuccess,
  Class_ETC_Warning,
  Class_ETC_Encrypt
} from "../Class/Class_Etc";
import { CP_CheckPermission } from "../Class/Class_Permission"
import MsgDescription from "../Class/MsgDescription.json";
import { Link } from "react-router-dom";
import PaginationActions from "../PartialView/PaginationActions"


/* Create By Poom : 08-05-2023 */
function M_project() {
  const pro_status = [
    { value: "-1", label: ConfigETC.ddl_All },
    { value: "1", label: "active" },
    { value: "0", label: "In-active" },
  ];

  const pro_is_close = [
    { value: "-1", label: ConfigETC.ddl_All },
    { value: "1", label: "Open" },
    { value: "0", label: "Close" },
  ];

  const animatedComponents = makeAnimated();
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [listcus, setListcus] = useState([""]);
  
  const [isPermissionview, setIsPermissionview] = useState(false);
  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionDel, setIsPermissionDel] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);


  const [_scus, set_Scus] = useState([]);
  const [_sstatus, set_Sstatus] = useState("-1");
  const [_sOC, set_SOC] = useState("-1");
  const [listdata, setListdata] = useState([]);
  const [ ActEdit ] = useState(Class_ETC_Encrypt("Edit"));
  const [ ActAdd ] = useState(Class_ETC_Encrypt("Add"));

  const [page, setPage] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };

  useEffect(() => {
    if (isLoadProgress === true) {
      let ckpermission = CP_CheckPermission("main" , ["projects_view"] , false , true)
      if (ckpermission === true) {
        setIsPermissionview(ckpermission);
        setIsPermissionEdit(CP_CheckPermission("main" , ["projects_edit"] , false , false))
        setIsPermissionDel(CP_CheckPermission("main" , ["projects_delete"] , false , false))
        setIsPermissionAdd(CP_CheckPermission("main" , ["projects_add"] , false , false))

        GetConfig();
        if (isLoadedConfigData === true) {
          BindDDL();
        }
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindDDL() {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        cus_status: "-1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Customer_Getlist",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          const arr = [];
          json.data.map((en) => {
            return arr.push({ value: en.cus_id, label: en.cus_name });
          });
          setListcus(arr);
          setIsLoadProgress(false);
        } else {
          setListcus([]);
          setIsLoadProgress(false);
        }
      }
    } catch {
      setListcus([]);
      setIsLoadProgress(false);
    }
  }

  function onclickSearch() {
    setIsSearch(true);
    setIsLoadProgress(true);
    BindList(true ,function() {
      setIsLoadProgress(false);
    });
  }

  async function BindList(isSearch = true , _callback) {
    try {
      let scus = "";
      if (_scus.length > 0) {
        for (let i = 0; i < _scus.length; i++) {
          scus = scus + (scus === "" ? "" : ",") + _scus[i].value;
        }
      }

      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        cus_id_list: scus,
        pro_status: _sstatus,
        pro_is_close: _sOC,
        pro_search_text: document
          .getElementById("txt_pro_search_text")
          .value.trim(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_Getlist",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (isSearch) {
            setPage(0);
          } else {
            if (rowsPerPage * (page + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPage);
              setPage(pagenow === 0 ? 0 : pagenow - 1);
            }
          }
          setListdata(json.data);
          if (_callback != null) {
              _callback();
          }
        } else {
          setPage(0);
          setListdata([]);
          if (_callback != null) {
              _callback();
          }
        }
      }
    } catch {
      setPage(0);
      if (_callback != null) {
          _callback();
      }
    }
  }

  function onclick_DelProject(pro_id) {
    document.getElementById("hd_iddel").value = pro_id;
    Class_ETC_Warning(MsgDescription.CFM002, DelProject);
  }

  async function DelProject() {
    setIsLoadProgress(true);
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: document.getElementById("hd_iddel").value.trim(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_Del",
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        BindList(false , function() {
          setIsLoadProgress(false);
          Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
        });
      } else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    }
  }

  return (
    <>
      <Helmet>
        <title>Project</title>
      </Helmet>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fa fa-building" /> Project list{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label>Customer</label>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        placeholder={ConfigETC.ddl_All}
                        isMulti
                        options={listcus}
                        menuPortalTarget={document.body}
                        onChange={(e) => set_Scus(e)}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Status</label>
                      <Select
                        options={pro_status}
                        placeholder={ConfigETC.ddl_All}
                        isClearable={true}
                        menuPortalTarget={document.body}
                        defaultValue={pro_status[0]}
                        onChange={(value) =>
                          set_Sstatus(value === null ? "-1" : value.value)
                        }
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label>Open/Closed</label>
                      <Select
                        options={pro_is_close}
                        placeholder={ConfigETC.ddl_All}
                        isClearable={true}
                        menuPortalTarget={document.body}
                        defaultValue={pro_is_close[0]}
                        onChange={(value) =>
                          set_SOC(value === null ? "-1" : value.value)
                        }
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group input-sm">
                    <input
                      id="txt_pro_search_text"
                      type="search"
                      className="form-control "
                      placeholder="Search by Project name ,  Project Year or Project type"
                    />
                    <div className="input-group-append">
                      <button
                        type="submit"
                        className="btn  btn-primary"
                        onClick={onclickSearch}
                      >
                        <i className="fa fa-search" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {isSearch && (
              <>
                <div className="row">
                  <div className="col-md-12 ">
                    <div className="card  shadow">
                      <div className="card-header ">
                        <h3 className="card-title">
                          Result <small> ({listdata.length} items)</small>
                        </h3>
                      </div>
                      <div className="card-body p-0">
                        <input type="hidden" id="hd_iddel"></input>
                        <TableContainer>
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            className="table table-head-fixed text-nowrap table-hover"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell width={"5%"} align={"left"}>
                                  <b>#</b>
                                </TableCell>
                                <TableCell width={"20%"} align={"left"}>
                                  <b>Customer</b>
                                </TableCell>
                                <TableCell width={"20%"} align={"left"}>
                                  <b>Project name</b>
                                </TableCell>
                                <TableCell width={"20%"} align={"left"}>
                                  <b>
                                    Project Year
                                    <br />
                                    Project type
                                  </b>
                                </TableCell>
                                <TableCell width={"20%"} align={"left"}>
                                  <b>Start Date - End Date</b>
                                </TableCell>
                                <TableCell width={"10%"} align={"left"}>
                                  <b>Status</b>
                                </TableCell>
                                <TableCell
                                  width={"5%"}
                                  align={"left"}
                                ></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(listdata.length === 0 && (
                                <TableRow key={1}>
                                  <TableCell colSpan={7} align="center">
                                    {ConfigETC.NoData}
                                  </TableCell>
                                </TableRow>
                              )) ||
                                listdata
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                                    <TableRow key={row.pro_id}>
                                      <TableCell>
                                        <div>{row.rowindex}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>{row.cus_name}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>{row.pro_name}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>{row.pro_year}</div>
                                        <div>{row.pro_type}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>
                                          {row.pro_start_date}{" "}
                                          {row.pro_start_date !== "" &&
                                          row.pro_start_date !== ""
                                            ? "-"
                                            : ""}{" "}
                                          {row.pro_end_date}
                                        </div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>
                                          <span
                                            className={
                                              row.pro_status === 1
                                                ? ConfigETC.Status_active
                                                : ConfigETC.Status_inactive
                                            }
                                          >
                                            {row.pro_status_str}
                                          </span>
                                        </div>
                                      </TableCell>

                                      <TableCell align="left">
                                        <div className="btn-group btn-group-sm">
                                          
                                          {(isPermissionEdit || isPermissionview) && 
                                            <Link
                                              to={"../" + Pathurl.m_project_ae}
                                              state={{
                                                proid: Class_ETC_Encrypt(row.pro_id.toString()),
                                                act: ActEdit
                                              }}
                                              className="btn btn-primary btn-sm"
                                            >
                                              <i className="fas fa-pencil-alt" />
                                            </Link>
                                          }

                                          {isPermissionDel &&
                                            <a
                                              href="#!"
                                              onClick={() =>
                                                onclick_DelProject(row.pro_id)
                                              }
                                              className="btn btn-default btn-sm"
                                            >
                                              <i className="fas fa-trash" />
                                            </a>
                                          }

                                        </div>
                                      </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {listdata.length > 0 && (
                          <TablePagination
                            rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                            component="div"
                            count={listdata.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={PaginationActions}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {(isPermissionAdd === true) &&
              <div className="row">
                <div className="col-md-12">
                  <Link
                    to={"../" + Pathurl.m_project_ae}
                    state={{ proid: Class_ETC_Encrypt('-1'), act: ActAdd }}
                    className="btn btn-primary float-right fix-at-top"
                  >
                    <i className="fa fa-plus" />
                  </Link>
                </div>
              </div>
            }


            {/* /.row (main row) */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_project;
